import { CheckoutJourney } from '../models/checkout-journey.types';
import { CustomerJourneyType } from '../models/checkout.model';

export const BOOKING_JOURNEY: CheckoutJourney = {
  type: CustomerJourneyType.BOOKING,
  searchRoute: '/search',
  stepLabels: ['Tilvalg', 'Personlig info', 'Betaling', 'Bekræftelse'],
  page: [
    {
      pageRoute: 'addons',
      label: 'Tilvalg',
      ariaLabel: 'Tilvalg',
      heroSubtitle: 'Gennemgå din booking og bekræft oplysningerne for at fortsætte.',
    },
    {
      pageRoute: 'personal-info',
      label: 'Personlig info',
      ariaLabel: 'Personlig info',
      heroSubtitle: 'Udfyld dine oplysninger for at fortsætte til betaling.',
      zoneConfig: {
        processingLabel: 'Forbereder betaling...',
      },
    },
    {
      pageRoute: 'payment-complete',
      label: 'Betaling',
      ariaLabel: 'Betaling',
      heroSubtitle: 'Vi bekræfter din betaling — vent et øjeblik.',
      isNavigable: false,
    },
    {
      pageRoute: 'complete',
      label: 'Bekræftelse',
      ariaLabel: 'Bekræftelse',
      zoneConfig: {
        summaryContent: {
          title: 'Booking bekræftet',
          message: 'Du modtager en bekræftelse på e-mail.\nVi glæder os til at se dig.',
          illustrationPath: './assets/illustrations/checkout-goalline.svg',
        },
      },
    },
  ],
};
